import Vue from 'vue'
import api from '../../api/api'

const exam = {
  state: {
    examList: []
  },

  mutations: {
    SET_EXAM_LIST(state, data) {
      state.examList = data
    }
  },

  actions: {
    //获取考级课程
    async getgradelessoninfos({ commit, rootState}) {
      let params = {
        lessionid:rootState.route.query.lessionid || 0,
        //name:rootState.route.query.name || ''
      }
      let ret = await api.getgradelessoninfos(params)
      if(params.lessionid == 0) {
        commit('SET_EXAM_LIST', ret.data)
      } else {
        commit('SET_EXAM_LIST', ret.data[0].childcurriculum)
      }
      
      console.log('考级课程列表', ret)
    }
  }

};

export default exam


// WEBPACK FOOTER //
// ./src/store/modules/exam.js